export default __webpack_public_path__ + "static/healthcare-fraud-img-2-9bebe7d59ec3a92b9e90ee304ac74e12.svg";